class User {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.email = data ? data.email : ''
    this.created_at = data ? data.created_at : ''
    this.email_verified = data ? data.email_verified_at ? 'Yes' : 'No' : ''
    this.submissions_count = data ? data.submissions_count : ''
    this.pending_submissions_count = data ? data.pending_submissions_count : ''
    this.password = ''
  }
}

export default User



// WEBPACK FOOTER //
// ./src/models/user.js